import { parse } from 'yaml';

import authEnYaml from './locales/en/auth.yaml?raw';
import commonEnYaml from './locales/en/common.yaml?raw';
import medicalEnYaml from './locales/en/medical.yaml?raw';
import myProfileEnYaml from './locales/en/my-profile.yaml?raw';
import termsPoliciesEnYaml from './locales/en/terms-policies.yaml?raw';
import validationEnYaml from './locales/en/validation.yaml?raw';

import authKoYaml from './locales/ko/auth.yaml?raw';
import commonKoYaml from './locales/ko/common.yaml?raw';
import medicalKoYaml from './locales/ko/medical.yaml?raw';
import myProfileKoYaml from './locales/ko/my-profile.yaml?raw';
import termsPoliciesKoYaml from './locales/ko/terms-policies.yaml?raw';
import validationKoYaml from './locales/ko/validation.yaml?raw';

type LocaleResource = Record<string, unknown>;

const readLocale = (source: string): LocaleResource => parse(source) as LocaleResource;

export const resources = {
  en: {
    auth: readLocale(authEnYaml),
    common: readLocale(commonEnYaml),
    medical: readLocale(medicalEnYaml),
    myProfile: readLocale(myProfileEnYaml),
    termsPolicies: readLocale(termsPoliciesEnYaml),
    validation: readLocale(validationEnYaml),
  },
  ko: {
    auth: readLocale(authKoYaml),
    common: readLocale(commonKoYaml),
    medical: readLocale(medicalKoYaml),
    myProfile: readLocale(myProfileKoYaml),
    termsPolicies: readLocale(termsPoliciesKoYaml),
    validation: readLocale(validationKoYaml),
  },
} as const;
